module.exports = __webpack_public_path__ + "static/img/label-icon2.3f38390f.png";